import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, commsHeader, indianProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { CREATE_COMS_CONFIG, CREATE_COMS_CONFIG_SUCCESS, CREATE_COMS_CONFIG_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* createComsConfig({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/comms/configs`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
        ...commsHeader,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: CREATE_COMS_CONFIG_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: CREATE_COMS_CONFIG_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_COMS_CONFIG_ERROR, payload: error });
  }
}

export function* watchCreateComsConfig() {
  yield takeEvery(CREATE_COMS_CONFIG, createComsConfig);
}

function* createComsConfigSaga() {
  yield all([fork(watchCreateComsConfig)]);
}

export default createComsConfigSaga;
